'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import useMergedRefs from '@restart/hooks/useMergedRefs';
import clsx from 'clsx';
import React from 'react';
import Button from '@mui/material/Button';
import { deprecatedDropdownCssClassNames } from './deprecatedDropdownCssClassNames';
import { useDeprecatedDropdownContext } from './hooks/useDeprecatedDropdownContext';
export const DeprecatedDropdownButton = React.forwardRef(({ className, component: Component = Button, endIcon = _jsx(KeyboardArrowDownIcon, {}), onClick, ...props }, ref) => {
    const { open, setOpen, anchorRef, dropdownMenuId } = useDeprecatedDropdownContext('Button');
    const mergedRef = useMergedRefs(anchorRef, ref);
    const handleClick = (event) => {
        setOpen(true);
        onClick?.(event);
    };
    return (_jsx(Component, { ...props, "aria-controls": open ? dropdownMenuId : undefined, "aria-expanded": open, "aria-haspopup": 'true', className: clsx(deprecatedDropdownCssClassNames.button, className), ...(Component === Button && {
            endIcon
        }), onClick: handleClick, onKeyDown: (event) => {
            if (event.code === 'Escape') {
                event.preventDefault();
                setOpen(false);
            }
        }, ref: mergedRef }));
});
DeprecatedDropdownButton.displayName = 'DeprecatedDropdownButton';
